import { apiClient } from '@/utils/api-client'

const API_INTERNAL_BASE = '/support/tickets'

class SupportTicketService {
    async create(form) {
        return await apiClient
            .post(API_INTERNAL_BASE, form)
            .then((response) => {
                return response.data
            })
    }
}

export default new SupportTicketService()
